import React from 'react';
import { Menu } from '@headlessui/react';
import classNames from 'classnames';

import CountryFlag from 'components/CountryFlag';
import { currentLanguage, LANGUAGES } from 'ui-brand/languages';

// Only for pages under i18n_patterns: the language is the first path segment.
const urlInLanguage = (code: string) => {
  const { pathname, search } = window.location;
  const segments = pathname.split('/');
  segments[1] = code;
  return `${segments.join('/')}${search}`;
};

function LanguageSelector() {
  const selected = currentLanguage();
  if (!selected) return null;

  return (
    <Menu as="div" className="relative">
      <Menu.Button
        className="flex min-h-12 items-center gap-2 rounded-lg p-3 text-sm font-semibold text-retino-darkviolet transition-colors hover:bg-white/70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-retino-darkviolet"
        aria-label={gettext('Change language')}
      >
        <CountryFlag country={selected.country} className="h-4 w-[22px] rounded-sm" />
        {selected.code.toUpperCase()}
      </Menu.Button>
      <Menu.Items className="absolute right-0 top-full z-10 mt-2 flex w-52 flex-col rounded-2xl bg-white p-2 shadow-lg outline-none">
        {LANGUAGES.map((language) => (
          <Menu.Item key={language.code}>
            {({ active }) => (
              <a
                href={urlInLanguage(language.code)}
                className={classNames(
                  'flex items-center gap-3 rounded-lg px-3 py-2 text-base text-retino-darkviolet',
                  active && 'bg-retino-beige',
                )}
              >
                <CountryFlag country={language.country} className="h-4 w-[22px] rounded-sm" />
                {language.label}
              </a>
            )}
          </Menu.Item>
        ))}
      </Menu.Items>
    </Menu>
  );
}

export default LanguageSelector;
